// Context.Tag identifiers for all services
export const ContextTag = {
  BackendApi: '@app/BackendApi',
  ApiConfig: '@app/ApiConfig',
  TenantConfig: '@app/TenantConfig',
  AuthToken: '@app/AuthToken',
  OrderToken: '@app/OrderToken',
  OrderShipment: '@app/OrderShipment',
  OrderService: '@app/OrderService',
  AlertMessagesDismissed: '@app/AlertMessagesDismissed',
  ProductsComparison: '@app/ProductsComparison',
  IntlContext: '@app/IntlContext',
  CookiesStore: '@app/CookiesStore',
  Navigation: '@app/Navigation',
  CheckboxFilterService: '@app/CheckboxFilterService',
  RangeFilterService: '@app/RangeFilterService',
  TextFilterService: '@app/TextFilterService',
  BrandFilterService: '@app/BrandFilterService',
  WarehouseFilterService: '@app/WarehouseFilterService',
  TaxonFilterService: '@app/TaxonFilterService',
  ProductsAccumulationService: '@app/ProductsAccumulationService',
  SupportBox: '@app/SupportBox',
  PacketaWidget: '@app/PacketaWidget',
  BalikovnaWidget: '@app/BalikovnaWidget',
  PplWidget: '@app/PplWidget',
  SlovakPostWidget: '@app/SlovakPostWidget',
  StorageSync: '@app/StorageSync',
  RefreshLock: '@app/RefreshLock',
} as const;
